(() => {
  if (window.ksCardLayoutLoaded) return;
  window.ksCardLayoutLoaded = true;
  const selector = 'product-grid-item.ks-card';
  const observed = new WeakSet();
  let scheduled = false;

  function alignRows() {
    scheduled = false;
    const cards = [...document.querySelectorAll(selector)].filter(card => card.getClientRects().length);
    const fields = ['title', 'price', 'promo'];
    cards.forEach(card => fields.forEach(field => card.style.removeProperty(`--ks-${field}-height`)));
    const rows = new Map();
    cards.forEach(card => {
      const parent = card.closest('.js-grid, .flickity-slider, .grid, .float-grid') || card.parentElement;
      if (!rows.has(parent)) rows.set(parent, new Map());
      const top = Math.round(card.getBoundingClientRect().top);
      const groups = rows.get(parent);
      const matchingTop = [...groups.keys()].find(value => Math.abs(value - top) <= 2);
      const key = matchingTop === undefined ? top : matchingTop;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(card);
    });
    rows.forEach(groups => groups.forEach(group => {
      const collapseEmptyPromo = window.innerWidth < 1440 && !group.some(card => {
        const promo = card.querySelector('product-grid-item-variant:not([hidden]) .ks-card__promo');
        return promo && promo.textContent.trim() !== '';
      });
      group.forEach(card => card.classList.toggle('ks-card--row-no-promo', collapseEmptyPromo));
      fields.forEach(field => {
        const max = Math.max(...group.map(card => {
          const element = card.querySelector(`product-grid-item-variant:not([hidden]) .ks-card__${field}`);
          return element ? element.getBoundingClientRect().height : 0;
        }));
        group.forEach(card => card.style.setProperty(`--ks-${field}-height`, `${Math.ceil(max)}px`));
      });
    }));
    const sliders = new Set(cards.map(card => card.closest('.flickity-enabled')).filter(Boolean));
    sliders.forEach(slider => window.themeVendor?.Flickity?.data(slider)?.resize());
    document.dispatchEvent(new CustomEvent('ks:cards:aligned'));
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(alignRows);
  }

  function cleanMyr(root = document) {
    root.querySelectorAll?.('[data-cart-final]').forEach(node => {
      const cleaned = node.textContent.replace(/\s+MYR\b/g, '').replace(/\bMYR\s*/g, 'RM');
      if (cleaned !== node.textContent) node.textContent = cleaned;
    });
  }

  const resize = new ResizeObserver(entries => {
    let changed = false;
    entries.forEach(entry => {
      const width = Math.round(entry.contentRect.width);
      if (entry.target.ksObservedWidth !== width) {
        entry.target.ksObservedWidth = width;
        changed = true;
      }
    });
    if (changed) schedule();
  });

  function initialize() {
    document.querySelectorAll(selector).forEach(card => {
      if (observed.has(card)) return;
      observed.add(card);
      resize.observe(card);
      new MutationObserver(schedule).observe(card, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
      card.querySelectorAll('.ks-card__size-menu').forEach(menu => {
        new MutationObserver(schedule).observe(menu, { attributes: true, attributeFilter: ['style'] });
      });
      card.addEventListener('click', event => {
        const swatch = event.target.closest('a[data-grid-item-variant]');
        if (!swatch) return;
        card.querySelectorAll('a[data-grid-item-variant]').forEach(link => {
          link.removeAttribute('aria-current');
          link.setAttribute('aria-selected', link === swatch ? 'true' : 'false');
        });
        swatch.setAttribute('aria-current', 'true');
        schedule();
      });
    });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) initialize();
  }).observe(document.documentElement, { subtree: true, childList: true });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('theme:cart:change', () => setTimeout(() => cleanMyr(), 0));
  document.addEventListener('theme:cart:reload', () => setTimeout(() => cleanMyr(), 100));
  document.addEventListener('theme:variant:change', event => {
    const variant = event.detail?.variant;
    const container = event.target.closest('[data-section-type="product"], [data-form-holder]') || event.target;
    container.querySelectorAll('[data-ks-pdp-discount]').forEach(label => {
      const compare = Number(variant?.compare_at_price);
      const price = Number(variant?.price);
      label.hidden = !variant || !(compare > price && compare > 0);
      if (!label.hidden) label.textContent = '-' + Math.round((compare - price) * 100 / compare) + '%';
    });
  });
  let pendingVariant = null;
  document.addEventListener('click', event => {
    const button = event.target.closest('.ks-card button[data-add-to-cart]');
    if (!button || button.disabled) return;
    const input = button.closest('form')?.querySelector('[name="id"]');
    if (input) pendingVariant = String(input.value);
  }, true);
  document.addEventListener('theme:cart:popdown', event => {
    if (!pendingVariant || String(event.detail?.variant?.id) !== pendingVariant) return;
    pendingVariant = null;
    const toggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (!toggle || window.theme?.state?.cartOpen) return;
    event.stopImmediatePropagation();
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    toggle.click();
    schedule();
  }, true);
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule, { once: true });
  new MutationObserver(records => {
    if (records.some(record => record.target.closest?.('[data-cart-final]') || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-cart-final]') || node.querySelector?.('[data-cart-final]'))))) cleanMyr();
  }).observe(document.documentElement, { subtree: true, childList: true, characterData: true });
  cleanMyr();
  if (document.fonts) document.fonts.ready.then(schedule);
})();
